// extracted by mini-css-extract-plugin
export default {"img":"v8aXsesNEJmFkQNcr8Zl","imgWrapper":"PXHtjyB0Z_yRV3LVUnNx","seniorCarousel":"Tle3FIKX76xgSWP7ZIuy","title":"uX5VL6NHI6vyBIg_By5A"};